import { addHours } from "date-fns";
import { Observable, WritableObservable } from "micro-observables";
import moment from "moment";
import { Livecourse } from "@domain/livecourse/livecourse";
import { Media } from "@domain/media/media";

export class LivecourseEditorController {
	private previousValues: Livecourse[];
	private readonly currentValueIndex = new WritableObservable(0);

	readonly livecourse: Observable<Livecourse>;

	constructor(initialLivecourse: Livecourse) {
		this.previousValues = [initialLivecourse];
		this.livecourse = this.currentValueIndex.transform((index) => this.previousValues[index]);
	}

	setInstantDates(): void {
		this.updateLivecourse({
			startDate: new Date(moment().format("YYYY-MM-DD hh:mm:ss")),
			endDate: new Date(moment().add(2, "h").format("YYYY-MM-DD hh:mm:ss")),
		});
	}

	updateLivecourse(livecourseUpdate: Partial<Livecourse>): void {
		const livecourse: Livecourse = { ...this.livecourse.get(), ...livecourseUpdate };
		this.previousValues = [...this.previousValues.slice(0, this.currentValueIndex.get() + 1), livecourse];
		this.currentValueIndex.set(this.currentValueIndex.get() + 1);
	}
	setBanner(banner?: Media): void {
		this.updateLivecourse({ banner });
	}
	setTitle(title: string): void {
		this.updateLivecourse({ title });
	}
	setDescription(description: string): void {
		if (description.length < 400) this.updateLivecourse({ description });
	}

	setWorkspaceId(workspaceId: string): void {
		this.updateLivecourse({ workspaceId });
	}
	setPostAutoPublish(postAutoPublish?: boolean): void {
		this.updateLivecourse({ postAutoPublish });
	}

	setStartDate(startDate: Date): void {
		this.updateLivecourse({ startDate, endDate: addHours(startDate, 1) });
	}
	setEndDate(endDate: Date): void {
		const { startDate } = this.livecourse.get();
		if (!startDate || endDate <= startDate) this.updateLivecourse({ endDate, startDate: addHours(endDate, -1) });
		else this.updateLivecourse({ endDate });
	}

	setStartDateClean(startDate: Date): void {
		this.updateLivecourse({ startDate });
	}
	setEndDateClean(endDate: Date): void {
		this.updateLivecourse({ endDate });
	}
	get isValid(): Observable<boolean> {
		return Observable.from(this.livecourse).transform(([livecourse]) => {
			if (!livecourse.title) {
				return false;
			}
			return true;
		});
	}
}
